/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { TeamMemberFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type TeamMembersQueryVariables = Exact<{
  teamID: string
}>

export type TeamMembersQuery = {
  __typename: "Query"
  teamMembers?: Array<{
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }> | null
}

export type TeamMemberQueryVariables = Exact<{
  teamID: string
  teamMemberID: string
}>

export type TeamMemberQuery = {
  __typename: "Query"
  teamMember?: {
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  } | null
}

export const TeamMembersDocument = gql`
  query TeamMembers($teamID: ID!) {
    teamMembers(teamID: $teamID)
      @rest(
        type: "TeamMember"
        path: "/project-list/teams/{args.teamID}/members"
      ) {
      ...TeamMember
    }
  }
  ${TeamMemberFragmentDoc}
`

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useTeamMembersQuery(
  baseOptions: Apollo.QueryHookOptions<
    TeamMembersQuery,
    TeamMembersQueryVariables
  > &
    (
      | { variables: TeamMembersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(
    TeamMembersDocument,
    options
  )
}
export function useTeamMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamMembersQuery,
    TeamMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(
    TeamMembersDocument,
    options
  )
}
// @ts-ignore
export function useTeamMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamMembersQuery,
    TeamMembersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<TeamMembersQuery, TeamMembersQueryVariables>
export function useTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamMembersQuery,
        TeamMembersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  TeamMembersQuery | undefined,
  TeamMembersQueryVariables
>
export function useTeamMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TeamMembersQuery,
        TeamMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TeamMembersQuery, TeamMembersQueryVariables>(
    TeamMembersDocument,
    options
  )
}
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>
export type TeamMembersLazyQueryHookResult = ReturnType<
  typeof useTeamMembersLazyQuery
>
export type TeamMembersSuspenseQueryHookResult = ReturnType<
  typeof useTeamMembersSuspenseQuery
>
export type TeamMembersQueryResult = Apollo.QueryResult<
  TeamMembersQuery,
  TeamMembersQueryVariables
>
export const TeamMemberDocument = gql`
  query TeamMember($teamID: ID!, $teamMemberID: ID!) {
    teamMember(teamID: $teamID, teamMemberID: $teamMemberID)
      @rest(
        type: "TeamMember"
        path: "/project-list/teams/{args.teamID}/members/{args.teamMemberID}"
      ) {
      ...TeamMember
    }
  }
  ${TeamMemberFragmentDoc}
`

/**
 * __useTeamMemberQuery__
 *
 * To run a query within a React component, call `useTeamMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      teamMemberID: // value for 'teamMemberID'
 *   },
 * });
 */
export function useTeamMemberQuery(
  baseOptions: Apollo.QueryHookOptions<
    TeamMemberQuery,
    TeamMemberQueryVariables
  > &
    (
      | { variables: TeamMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TeamMemberQuery, TeamMemberQueryVariables>(
    TeamMemberDocument,
    options
  )
}
export function useTeamMemberLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TeamMemberQuery,
    TeamMemberQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TeamMemberQuery, TeamMemberQueryVariables>(
    TeamMemberDocument,
    options
  )
}
// @ts-ignore
export function useTeamMemberSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TeamMemberQuery,
    TeamMemberQueryVariables
  >
): Apollo.UseSuspenseQueryResult<TeamMemberQuery, TeamMemberQueryVariables>
export function useTeamMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>
): Apollo.UseSuspenseQueryResult<
  TeamMemberQuery | undefined,
  TeamMemberQueryVariables
>
export function useTeamMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<TeamMemberQuery, TeamMemberQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<TeamMemberQuery, TeamMemberQueryVariables>(
    TeamMemberDocument,
    options
  )
}
export type TeamMemberQueryHookResult = ReturnType<typeof useTeamMemberQuery>
export type TeamMemberLazyQueryHookResult = ReturnType<
  typeof useTeamMemberLazyQuery
>
export type TeamMemberSuspenseQueryHookResult = ReturnType<
  typeof useTeamMemberSuspenseQuery
>
export type TeamMemberQueryResult = Apollo.QueryResult<
  TeamMemberQuery,
  TeamMemberQueryVariables
>
